/*
 * @Author: 勇城
 * @Date: 2021-08-18 11:51:44
 * @LastEditTime: 2021-09-03 11:30:25
 * @FilePath: \yimob\src\pages\ask\askIndex\components\FindACoach.js
 */
import '../style/FindACoach.scss'
import api from '../api'
import Bridge from 'src/frontend-lib/lib/Bridge'
let myBridge = new Bridge()
class FindACoach {
  constructor({ chat_coach_user = {}, pay_coach_user = {} } = {}) {
    this.chat_coach_user = chat_coach_user
    this.pay_coach_user = pay_coach_user
    this.list = ['请选择服务类目', '付费问答', '心探陪聊', '测评解读']
    this.renderHTML()
    this.bindEvent()
  }

  mixinIsApp() {
    const { isYixinliApp, isZiXunApp, isZiXunShiApp } = window.$platform
    return isYixinliApp || isZiXunApp || isZiXunShiApp
  }
  renderHTML() {
    let html = `
    <div class="FindACoachDialogDottom">
      <div class="mask"></div>
        <div class="FindACoachContent">
          <div class="FindACoach">
            <div class="list">
            ${this.list
              .map(
                (item, index) => `
              <div
                data-index=${index}
                class="item ${index ? 'index' : ''}"
              >
                ${item}
              </div>
              `
              )
              .join('')}
            </div>
          </div>
          <div class="bottom-btn">
            <div class="btn">取消</div>
          </div>
        </div>
    </div>
    `
    $('.container').append(html)
  }
  bindEvent() {
    let that = this
    $('.FindACoachDialogDottom').on('click', '.mask', () => {
      $('.FindACoachDialogDottom').hide()
    })
    $('.FindACoachDialogDottom').on('click', '.bottom-btn .btn', () => {
      $('.FindACoachDialogDottom').hide()
    })
    $('.FindACoachDialogDottom').on('click', '.list .item', function() {
      if (+$(this).data('index')) {
        window.yxl.stat.send({
          name: '问答-交互行为',
          properties: {
            行为: '点击',
            页面: '首页',
            对象: `服务列表页-立即找教练-${$(this)
              .html()
              .trim()}`
          }
        })
        if ([1, 3].includes($(this).data('index'))) {
          if (that.pay_coach_user.user_id) {
            return that.userIndex(that.pay_coach_user.user_id)
          }
        } else {
          if (that.chat_coach_user.user_id) {
            return that.userIndex(that.chat_coach_user.user_id)
          }
        }
        return window.toast('当前无空闲中的教练，可在1-2小时候下单')
      }
    })
  }

  userIndex(id) {
    setTimeout(() => {
      let url = `${api.static}/msite/index.html#/heart-search/service-index?id=${id}`
      if (this.mixinIsApp()) {
        myBridge.call('openWebView', {
          url,
          isCurrentPageOpen: 0,
          hideNavigationBar: 1
        })
        this.openWebView({
          url
        })
      } else {
        window.location.href = url
      }
    }, 300)
  }
}
module.exports = function(data) {
  console.log(data)
  if ($('.FindACoachDialogDottom').length > 0) {
    $('.FindACoachDialogDottom').show()
  } else {
    new FindACoach(data)
  }
}



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/components/FindACoach.js